export enum AlertState {
    NEW,
    READ,
    NONE
}

export type Tag = {
    id: string,
    description: string,
    owner: string,
    disabled: boolean,
    alert: AlertState,
    deleted: boolean
};
